"use client";

import { useEffect, useState } from "react";
import { getNextBoundary, resolveTheme } from "./themeUtils";

let globalTheme = "dark";
const listeners = new Set();

const applyTheme = (newTheme) => {
  globalTheme = newTheme;
  document.documentElement.setAttribute("data-theme", newTheme);
  listeners.forEach((listener) => listener(newTheme));
};

const setManualTheme = (newTheme) => {
  const nextBoundary = getNextBoundary(new Date());
  localStorage.setItem("theme", newTheme);
  localStorage.setItem("themeOverrideUntil", nextBoundary.getTime().toString());
  applyTheme(newTheme);
};

export default function useTheme() {
  const [theme, setTheme] = useState(globalTheme);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const initialTheme = resolveTheme();
    globalTheme = initialTheme;
    setTheme(initialTheme);
    document.documentElement.setAttribute("data-theme", initialTheme);

    const handleThemeChange = (newTheme) => setTheme(newTheme);
    listeners.add(handleThemeChange);
    setMounted(true);

    const checkThemeInterval = setInterval(() => {
      const resolved = resolveTheme();
      if (resolved !== globalTheme) {
        applyTheme(resolved);
      }
    }, 60000);

    return () => {
      listeners.delete(handleThemeChange);
      clearInterval(checkThemeInterval);
    };
  }, []);

  const toggleTheme = () => {
    const nextTheme = globalTheme === "dark" ? "light" : "dark";
    setManualTheme(nextTheme);
  };

  return { theme, toggleTheme, mounted };
}
